import { render, staticRenderFns } from "./xisnhiTanchu.vue?vue&type=template&id=685a2bd1&scoped=true"
import script from "./xisnhiTanchu.vue?vue&type=script&lang=js"
export * from "./xisnhiTanchu.vue?vue&type=script&lang=js"
import style0 from "./xisnhiTanchu.vue?vue&type=style&index=0&id=685a2bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685a2bd1",
  null
  
)

export default component.exports